import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dropdown-menu';
import { cn } from '@Utils/cn';
import { CircleUserRound, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/auth';

export default function AccountButton() {
  const { logout } = useAuth();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <CircleUserRound className="h-5! w-5!" />
          <span className="sr-only">Account</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        {/* <DropdownMenuLabel>
          <div>My Account</div>
        </DropdownMenuLabel>
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link href="/account" className="w-full cursor-pointer">
              <User className="mr-2 inline h-4 w-4" />
              <span>Profile</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              href="/account/notification-preferences"
              className="w-full cursor-pointer"
            >
              <Settings className="mr-2 inline h-4 w-4" />
              <span>Notification preferences</span>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator /> */}
        <DropdownMenuItem asChild>
          <Button
            type="button"
            className={cn('w-full cursor-pointer justify-start')}
            variant="ghost"
            size="sm"
            onClick={logout}
          >
            <LogOut className="mr-2 inline h-4 w-4" />
            <span>Log out</span>
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
